webpackJsonp([114276838955818,60335399758886],{

/***/ 114:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(242);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(114);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.901c001b.svg";

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(8);
	
	var _logo = __webpack_require__(222);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterContainer = _styledComponents2.default.footer.withConfig({
	  displayName: "Footer__FooterContainer"
	})(["position:relative;padding:50px 0;color:", ";background-color:white;border-top:2px solid ", ";@media screen and (max-width:768px){padding:25px 10px;}"], _colors.ACTIVE_TEXT, _colors.ACTIVE_TEXT);
	
	var FooterWrapper = _styledComponents2.default.div.withConfig({
	  displayName: "Footer__FooterWrapper"
	})(["max-width:1000px;margin:0 auto;width:100%;display:flex;justify-content:space-between;a{transition:all 200ms ease;:hover{transform:translateY(-2px);}}@media (max-width:768px){width:90%;flex-direction:column;padding-bottom:100px;}@media (max-width:615px){width:90%;flex-direction:column;padding-bottom:150px;}"]);
	
	var FooterInfo = _styledComponents2.default.div.withConfig({
	  displayName: "Footer__FooterInfo"
	})(["width:520px;max-width:100%;a{padding:5px 0px;}"]);
	
	var FooterForm = _styledComponents2.default.div.withConfig({
	  displayName: "Footer__FooterForm"
	})(["width:520px;padding-right:20px;max-width:100%;"]);
	
	var FooterSocial = _styledComponents2.default.div.withConfig({
	  displayName: "Footer__FooterSocial"
	})(["display:flex;justify-content:flex-end;list-style-type:none;padding:0;margin:0px 0px 20px 0px;a{margin-right:20px;font-size:24px;border:none;}@media screen and (max-width:768px){justify-content:flex-start;padding-top:25px;}"]);
	
	var FooterLinks = _styledComponents2.default.div.withConfig({
	  displayName: "Footer__FooterLinks"
	})(["display:flex;flex-direction:column;align-items:flex-start;"]);
	var FooterTerms = (0, _styledComponents2.default)(_gatsbyLink2.default).withConfig({
	  displayName: "Footer__FooterTerms"
	})([""]);
	
	var FooterCopyright = _styledComponents2.default.div.withConfig({
	  displayName: "Footer__FooterCopyright"
	})(["display:flex;position:relative;flex-direction:column;text-align:right;a{transition:all 200ms ease;:hover{transform:translateY(-2px);}}@media screen and (max-width:768px){text-align:left;}"]);
	
	var FooterMap = _styledComponents2.default.div.withConfig({
	  displayName: "Footer__FooterMap"
	})(["display:flex;a{font-size:17px;line-height:28px;}@media screen and (max-width:768px){font-size:15px;line-height:19px;}"]);
	
	var Footer = function Footer(props) {
	  return _react2.default.createElement(
	    FooterContainer,
	    null,
	    _react2.default.createElement(
	      FooterWrapper,
	      null,
	      _react2.default.createElement(
	        FooterInfo,
	        null,
	        _react2.default.createElement("img", { src: _logo2.default, style: { height: "28px", marginBottom: "20px" } }),
	        _react2.default.createElement(
	          FooterMap,
	          null,
	          _react2.default.createElement(
	            "div",
	            { style: { display: "flex", flexDirection: "column" } },
	            _react2.default.createElement(
	              FooterTerms,
	              { to: "/terms" },
	              "TinyMerch Terms"
	            ),
	            _react2.default.createElement(
	              "a",
	              { href: "https://my.tinymerch.com" },
	              "Seller Dashboard"
	            ),
	            _react2.default.createElement(
	              "a",
	              { href: "mailto:team@tinymerch.com" },
	              "Contact Us"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              style: {
	                display: "flex",
	                flexDirection: "column",
	                marginLeft: "60px"
	              } },
	            _react2.default.createElement(
	              "a",
	              { href: "#" },
	              "TinyMerch Gallery \u2013 Coming Soon!"
	            ),
	            _react2.default.createElement(
	              "a",
	              { href: "#" },
	              "TinyMerch Docs \u2013\xA0Coming Soon!"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { style: { display: "flex", flexDirection: "column" } },
	        _react2.default.createElement(
	          FooterSocial,
	          null,
	          _react2.default.createElement(
	            "a",
	            { href: "https://twitter.com/tinymerch" },
	            _react2.default.createElement("i", { className: "fa fa-twitter", "aria-hidden": "true" })
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "https://facebook.com/tinymerch" },
	            _react2.default.createElement("i", { className: "fa fa-facebook", "aria-hidden": "true" })
	          )
	        ),
	        _react2.default.createElement(
	          FooterCopyright,
	          null,
	          _react2.default.createElement(
	            "p",
	            { style: { color: "rgba(90,88,94,1)" } },
	            "Copyright ",
	            _react2.default.createElement(
	              "a",
	              { href: "http://nicer.io/" },
	              "Nicer LLC"
	            ),
	            ",",
	            " ",
	            new Date().getFullYear()
	          ),
	          _react2.default.createElement(
	            "p",
	            { style: { color: "rgba(90,88,94,1)" } },
	            "Built during the",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { href: "https://www.producthunt.com/hackathon" },
	              "ProductHunt Global Hackathon"
	            ),
	            " "
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo = __webpack_require__(222);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = _styledComponents2.default.nav.withConfig({
	  displayName: "Nav__Container"
	})(["z-index:9001;position:fixed;top:0;left:0;right:0;width:100%;background-color:white;@media (max-width:480px){position:absolute;}"]);
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	  displayName: "Nav__Wrapper"
	})(["width:100%;margin:0 auto;padding:0 50px;max-width:1600px;display:flex;align-items:center;justify-content:space-between;"]);
	
	var Brand = _styledComponents2.default.div.withConfig({
	  displayName: "Nav__Brand"
	})([""]);
	
	var Logo = _styledComponents2.default.img.withConfig({
	  displayName: "Nav__Logo"
	})(["margin-top:4px;height:32px;@media (max-width:768px){margin-top:10px;height:24px;}"]);
	
	var PagesList = _styledComponents2.default.ul.withConfig({
	  displayName: "Nav__PagesList"
	})(["margin:0;padding:0;display:flex;align-items:baseline;list-style-type:none;li{display:flex;align-items:center;height:60px;margin-left:30px;.PageLink{display:block;line-height:24px;border-bottom:2px solid transparent;}.PageLink:hover,.PageLink-active{color:", ";border-bottom-color:", ";}}@media (max-width:768px){overflow:hidden;position:absolute;top:100%;left:0;right:0;flex-direction:column;background-color:white;height:", "px;transition:height ", "ms ease-out;li{height:50px margin-left:20px;}}"], _colors.ACTIVE_TEXT, _colors.ACTIVE_TEXT, function (props) {
	  return props.expand ? 50 * 4 : 0;
	}, function (props) {
	  return props.expand ? 100 : 0;
	});
	
	var Button = _styledComponents2.default.a.withConfig({
	  displayName: "Nav__Button"
	})(["display:block;padding:5px 20px;background-color:white;border-radius:10px;box-shadow:0 5px 10px 0 rgba(0,0,0,0.1);transition:all 150ms;cursor:pointer;&:hover{transform:translateY(-1px);}"]);
	
	var LoginButton = _styledComponents2.default.button.withConfig({
	  displayName: "Nav__LoginButton"
	})(["display:block;padding:5px 20px;background-color:white;border-radius:10px;box-shadow:0 5px 10px 0 rgba(0,0,0,0.1);transition:all 150ms;border:none;outline:none;color:", ";font-family:karla;font-weight:700;font-size:16px;cursor:pointer;position:relative;top:5px;&:hover{transform:translateY(-1px);}"], _colors.ACTIVE_TEXT);
	
	var MenuButton = (0, _styledComponents2.default)(LoginButton).withConfig({
	  displayName: "Nav__MenuButton"
	})(["@media (min-width:769px){display:none;}"]);
	
	function PageLink(props) {
	  return _react2.default.createElement(_gatsbyLink2.default, _extends({}, props, { className: "PageLink", activeClassName: "PageLink-active" }));
	}
	
	var Nav = function (_Component) {
	  _inherits(Nav, _Component);
	
	  function Nav() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Nav);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      expand: false
	    }, _this.toggleMenu = function () {
	      _this.setState({ expand: !_this.state.expand });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Nav.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.location.pathname !== this.props.location.pathname) {
	      this.setState({ expand: false });
	    }
	  };
	
	  Nav.prototype.render = function render() {
	    return _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Brand,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" },
	            _react2.default.createElement(Logo, { src: _logo2.default })
	          )
	        ),
	        _react2.default.createElement(
	          PagesList,
	          { expand: this.state.expand },
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              PageLink,
	              { to: "/blog" },
	              "Blog"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              PageLink,
	              { to: "/faq/what-is" },
	              "FAQ"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              PageLink,
	              { to: "/demo" },
	              "Demo Store"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              Button,
	              { href: "https://my.tinymerch.com/" },
	              "Login"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          MenuButton,
	          { onClick: this.toggleMenu },
	          "Menu"
	        )
	      )
	    );
	  };
	
	  return Nav;
	}(_react.Component);
	
	exports.default = Nav;
	module.exports = exports["default"];

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Layout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ScreensizeProvider = __webpack_require__(30);
	
	var _ScreensizeProvider2 = _interopRequireDefault(_ScreensizeProvider);
	
	var _Footer = __webpack_require__(240);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Nav = __webpack_require__(241);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = _styledComponents2.default.div.withConfig({
	  displayName: "layouts__Container"
	})(["margin:0 auto;width:100%;max-width:1400px padding:1rem 1.5rem;@media (max-width:768px){padding-top:50px;}"]);
	
	function Layout(_ref) {
	  var children = _ref.children,
	      location = _ref.location;
	
	  console.log("Layout");
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(_Nav2.default, { location: location }),
	    _react2.default.createElement(
	      _ScreensizeProvider2.default,
	      null,
	      children()
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	}
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-0563dba351b1865c888d.js